import { render, staticRenderFns } from "./VotePage.vue?vue&type=template&id=0896ed39&"
import script from "./VotePage.vue?vue&type=script&lang=js&"
export * from "./VotePage.vue?vue&type=script&lang=js&"
import style0 from "./VotePage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports